import PropTypes from 'prop-types';

export const TaxBookingEntityPropTypes = PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  companyCode: PropTypes.string.isRequired,
  legalEntity: PropTypes.string.isRequired,
  tbeType: PropTypes.string,
  tbeLegalEntity: PropTypes.string,
  tbeCompanyCode: PropTypes.string,
  leLocalTaxType: PropTypes.string,
  leUStaxType: PropTypes.string,
  ownership: PropTypes.number,
  activeFlag: PropTypes.string.isRequired,
  importStatusDetail: PropTypes.number,
  importValidation: PropTypes.string, // eslint-disable-line camelcase
});

export const TaxBookingEntitiesPropTypes = PropTypes.arrayOf(TaxBookingEntityPropTypes).isRequired;
